/* @generated */

// src/assets/ui-icon/line/underline.tsx
import * as React from "react";
var UnderlineLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M7.5 5.5v7.265C7.53 15.31 9.003 17 12 17s4.47-1.69 4.5-4.235V5.5H15v7.186c0 1.017-.285 1.672-.681 2.073-.392.396-1.088.74-2.319.74-1.23 0-1.927-.344-2.319-.74-.396-.4-.681-1.056-.681-2.073V5.5H7.5ZM6 18.5V20h12v-1.5H6Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UnderlineLine
};
